import { useAuth } from "../contexts/AuthContext";
import OrganizerDashboard from "./dashboards/OrganizerDashboard";
import ExhibitorDashboard from "./dashboards/ExhibitorDashboard";
import VenueOwnerDashboard from "./dashboards/VenueOwnerDashboard";
import ProviderDashboard from "./dashboards/ProviderDashboard";
import VisitorDashboard from "./dashboards/VisitorDashboard";
import AdminDashboard from "./dashboards/AdminDashboard";

export default function Dashboard() {
  const { user } = useAuth();
  if (!user) return null;

  switch (user.role) {
    case "admin": return <AdminDashboard />;
    case "organizer": return <OrganizerDashboard />;
    case "exhibitor": return <ExhibitorDashboard />;
    case "venue_owner": return <VenueOwnerDashboard />;
    case "provider": return <ProviderDashboard />;
    default: return <VisitorDashboard />;
  }
}
